import { rest } from 'msw'
import { REPORTING_PATH } from 'services/TransactionExportService'
import {
  ReportSchedule,
  ReportSchedulesResponse,
  ReportScheduleTimeZone,
} from 'types/transactionsExport'
import mockReportSchedules from '../../../__mocks__/WalletTransactionsExport/reportSchedules.json'
import mockTimezones from '../../../__mocks__/WalletTransactionsExport/timezones.json'

export const getReportSchedules = rest.get<ReportSchedulesResponse>(
  `${API_URL}${REPORTING_PATH}`,
  async (req, res, ctx) => {
    return res(ctx.json(mockReportSchedules))
  }
)

export const getReportSchedulesEmpty = rest.get<ReportSchedulesResponse>(
  `${API_URL}${REPORTING_PATH}`,
  async (req, res, ctx) => {
    return res(ctx.json([]))
  }
)

export const getReportSchedulesError = rest.get<ReportSchedulesResponse>(
  `${API_URL}${REPORTING_PATH}`,
  async (req, res, ctx) => {
    return res(ctx.status(400), ctx.json([]))
  }
)

export const getReportScheduleTimezones = rest.get<ReportScheduleTimeZone[]>(
  `${API_URL}${REPORTING_PATH}/timezones`,
  async (req, res, ctx) => {
    return res(ctx.json(mockTimezones))
  }
)

export const postReportSchedule = rest.post<ReportSchedule>(
  `${API_URL}${REPORTING_PATH}`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({}))
  }
)

export const postReportScheduleError = rest.post<ReportSchedule>(
  `${API_URL}${REPORTING_PATH}`,
  async (req, res, ctx) => {
    return res(ctx.status(400), ctx.json({}))
  }
)

export const putReportSchedule = rest.put<ReportSchedule>(
  `${API_URL}${REPORTING_PATH}/*`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({}))
  }
)

export const putReportScheduleError = rest.put<ReportSchedule>(
  `${API_URL + REPORTING_PATH}/*`,
  async (req, res, ctx) => {
    return res(ctx.status(400), ctx.json({}))
  }
)

export const deleteReportSchedule = rest.delete(
  `${API_URL}${REPORTING_PATH}/*`,
  async (req, res, ctx) => {
    return res(ctx.status(200))
  }
)

export const deleteReportScheduleError = rest.delete(
  `${API_URL}${REPORTING_PATH}/*`,
  async (req, res, ctx) => {
    return res(ctx.status(400))
  }
)

export default [
  getReportSchedules,
  getReportSchedulesEmpty,
  getReportSchedulesError,
  getReportScheduleTimezones,
  postReportSchedule,
  postReportScheduleError,
  putReportSchedule,
  putReportScheduleError,
  deleteReportSchedule,
  deleteReportScheduleError,
]
